import React from 'react';
import {useTranslation} from 'react-i18next';

export const ViewNotFound = () => {
    const { t } = useTranslation();
    return (
        <div className="jumbotron jumbotron-fluid bg-white mt-3">
            <div className="container">
                <h1 className="display-4">{t('felsida.rubrik')}</h1>
                <p className="lead">{t('felsida.infotext')}</p>
            </div>
        </div>
    )
}
